import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  flex: 1;
  margin: 20px 20px 0 20px;
  flex-flow: column;
  position: relative;
  height: calc(100vh - 60px);
  justify-content: center;
  display: flex;
  hr {
    margin: 15px 0 10px 0;
    border: 1px solid ${props => props.theme.colors.color6b7786};
  }
`

export const DetailsContainer = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  flex-flow: column;
  height: 88%;
  flex: 1 1 auto;

  padding-right: 4px;
  ${VerticalStyledScrollBar}
`

export const MessageError = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
`
